import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert,Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { postDataLogin } from '../ApiServices/ApiService';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 
// import LoginNav from './LoginNav';
import LoginNavLoginPage from './LoginNav_LoginPage';
import FooterPage from './FooterPage';

const LoginDetails = () => {
  const navigate = useNavigate();

  const [organizationId, setOrganizationId] = useState('');
  const [email, setEmail] = useState('');
  const [forgotEmail, setForgotEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if(!email){
      setError('Please Enter Email.');
      return;
    }
    if(!password){
      setError('Please Enter Password.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const payload = {
      // "op": "LOGIN_ADMIN",
      "email": email.toLowerCase(), 
      "password": password
      // "organization_id":organizationId 
    }

    try {
      await postDataLogin('/admin/admin_login',payload).then(resp => {
        if(resp.statusCode === 200){
          if(resp.message.toLowerCase() === 'success'){
            // const orgID=resp.dataJ.organization_id
            // localStorage.setItem("org_id",orgID)
            // setTimeout(() => {
              setLoading(false);
            // }, 3000);
            
            if(resp.info ==='Change password and Login again'){
              setSuccess(resp.info);
              setTimeout(() => {
                navigate('/change-pwd', {state: { email: email.toLocaleLowerCase(), tempPassword: password }});                
              }, 2000);
            }else{
              const orgID=resp?.dataJ?.organization_id
              localStorage.setItem("org_id",orgID);
              setSuccess(resp.info); 
              localStorage.setItem("ai-admin", JSON.stringify(resp.dataJ));
              // setTimeout(() => {
                if(resp?.dataJ?.country_code === "+91"){
                  navigate("/job-post");
                }else{
                  sendOTP();
                  navigate("/MFA", {state: { email: email.toLocaleLowerCase()}});  
                }

                // navigate("/MFA", {state: { email: email.toLocaleLowerCase()}});              
              // }, 1000);
            }
          }else{
            setLoading(false);
            setError(resp.info); 
          }
       
        }else if(resp.statusCode === 500){
          setLoading(false);
          setError(resp.info);        
        }else{
          setLoading(false);
          setError('Login failed. Please check your credentials.');
        }
      }).catch((error) => {
        setLoading(false);
        setError('Login failed. Please check your credentials or Network Error');
        console.log('network error:', error);
      });
    } catch (error) {
      setLoading(false);
      setError('Login failed. Please check your credentials or Network Error');
      // Handle login error, e.g., display an error message to the user.
      console.error('Login failed', error);
    }


    // Your login logic goes here
    // For simplicity, I'll just show a success message
    // setSuccess('Login successful!');
  };

  const sendForgotPassword = async ()=>{
    setError('')
    setSuccess('')
    if(!forgotEmail){
      setError('Please Enter Email.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(forgotEmail)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const payload = {
      "op": "FORGET-PASSWORD",
      "email": forgotEmail.toLowerCase()
    }

    try {
      await postDataLogin('/admin/admin_forget_password',payload).then(resp => {
        if(resp.statusCode === 200){
          if(resp.message.toLowerCase() === 'success'){
              setLoading(false);
              setSuccess(resp.info)
              setTimeout(() => {
                navigate('/forgot-pwd', {state: { email: forgotEmail.toLocaleLowerCase()}});                
              }, 3000);
          }else{
            setLoading(false);
            setError(resp.info); 
          }
       
        }else if(resp.statusCode === 500){
          setLoading(false);
          setError(resp.info);        
        }else{
          setLoading(false);
          setError('Forgot Password failed. Please check your credentials.');
        }
      }).catch((error) => {
        setLoading(false);
        setError('Forgot Password failed. Please check your credentials or Network Error');
        console.log('network error:', error);
      });
    } catch (error) {
      setLoading(false);
      setError('Forgot Password failed. Please check your credentials or Network Error');
      // Handle login error, e.g., display an error message to the user.
      console.error('Forgot Password failed', error);
    }
  }

  const handleForgotPassword = ()=>{
    setShowForgotPassword(!showForgotPassword);
  }

  const sendOTP = async ()=>{
    setError('')
    setSuccess('')
    setLoading(true);
    const payload = {
      // "op": "SEND-OTP",
      "email": email
    }

    try {
      await postDataLogin('/admin/send_otp',payload).then(resp => {
        if(resp.statusCode === 200){
          if(resp.message.toLowerCase() === 'success'){
              setLoading(false);
              setSuccess(resp.info)
              // navigate("/MFA", {state: { email: email.toLocaleLowerCase()}});
          }else{
            setLoading(false);
            setError(resp.info); 
          }
       
        }else if(resp.statusCode === 500){
          setLoading(false);
          setError(resp.info);        
        }else{
          setLoading(false);
          setError('Failed To Send OTP. Please check your credentials.');
        }
      }).catch((error) => {
        setLoading(false);
        setError('Failed To Send OTP. Please check your credentials or Network Error');
        console.log('network error:', error);
      });
    } catch (error) {
      setLoading(false);
      setError('Failed To Send OTP. Please check your credentials or Network Error');
      // Handle login error, e.g., display an error message to the user.
      console.error('Failed To Send OTP', error);
    }
  }

  return (
    <>
    <LoginNavLoginPage></LoginNavLoginPage>
    <div className="outerContainer background-img-2">
      
      <div className='w-100'>
        {showForgotPassword ? <>
          <h2 className='login-heading'><span style={{color:'blue'}}>Engage</span>Talent.AI - Forgot Password</h2>
      <Container className='mainContainer'>
      <div className='formContainer container-width'>
      <Row >
        <Col md={6}>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <Form className="Form" onSubmit={sendForgotPassword}>
            {/* <Form.Group controlId="organizationId" className='input-box margin-bottom'>
              <Form.Control
                className="Form.Control placehold-padding"
                type="text"
                placeholder="Enter Organization ID"
                value={organizationId}
                onChange={(e) => setOrganizationId(e.target.value)}
              />
            </Form.Group> */}

            <Form.Group controlId="email" className='input-box margin-bottom'>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                className="placehold-padding"
              />
            </Form.Group>
    

            <Button variant="dark" type="submit" className="Button">
              Submit
            </Button>
            {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
          </Form>
          <div className="mt-3 link">
            <p className='Links__paragraph forgot-p-sty' onClick={handleForgotPassword}>
              Login
            </p>
          </div>
        </Col>
        <Col md={6} className='background-img'>

        </Col>
      </Row>
      </div>
      </Container>
        </>:<>
        <h2 className='login-heading'><span style={{color:'blue'}}>Engage</span>Talent.AI - Login</h2>
      <Container className='mainContainer'>
      <div className='formContainer container-width'>
      <Row >
        <Col md={6}>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <Form className="Form" onSubmit={handleSubmit}>
            {/* <Form.Group controlId="organizationId" className='input-box margin-bottom'>
              <Form.Control
                className="Form.Control placehold-padding"
                type="text"
                placeholder="Enter Organization ID"
                value={organizationId}
                onChange={(e) => setOrganizationId(e.target.value)}
              />
            </Form.Group> */}

            <Form.Group controlId="email" className='input-box margin-bottom'>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="placehold-padding"
              />
            </Form.Group>

            <Form.Group controlId="password" className="input-box margin-bottom">
            <div className="input-box-wrap">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='input-box-style placehold-padding'
                style={{border:'none'}}
              />
              <div className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
          </Form.Group>
    

            <Button variant="dark" type="submit" className="Button">
              Submit
            </Button>
            {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
          </Form>
          
          <div className="mt-3 link">
            <p className='Links__paragraph forgot-p-sty' onClick={handleForgotPassword}>
              Forgot password?
            </p>
          </div>
        </Col>
        <Col md={6} className='background-img'>

        </Col>
      </Row>
      </div>
      </Container>
        </>}

      </div>
    </div>
    {/* <FooterPage></FooterPage> */}
    </>
    
       
     
  );
};

export default LoginDetails;